import { Component, Input } from '@angular/core';
import { TaskJobDto } from '../../../models/server/DataTransferObject/Objects/TaskJobs';
import { ModalController } from '@ionic/angular';
import { TaskJobState } from '../../../models/server/Enums';

@Component({
  selector: 'app-task-progress-modal',
  templateUrl: './task-progress-modal.component.html',
  styleUrls: ['./task-progress-modal.component.scss']
})
export class TaskProgressModalComponent {
  @Input() public parentJob: TaskJobDto;
  @Input() public currentJobIndex: number;

  constructor(
    protected modalController: ModalController
  ) {
  }

  public dismiss(): void {
    this.modalController.dismiss({
      'dismissed': true
    });
  }

  public selectJob(jobIndex: number): void {
    this.modalController.dismiss({
      'dismissed': true,
      selectedJob: jobIndex
    });
  }

  public isJobDone(job: TaskJobDto): boolean {
    return job.jobStatus.some(jobStatus => jobStatus.status === TaskJobState.Done);
  }

  public isJobInProgress(job: TaskJobDto): boolean {
    return !this.isJobDone(job) && !this.isJobCancelled(job);
  }

  public isJobCancelled(job: TaskJobDto): boolean {
    return job.jobStatus.some(jobStatus => jobStatus.status === TaskJobState.Canceled);
  }

  public isJobDisabled(job: TaskJobDto, index: number): boolean {
    if (index === this.currentJobIndex) {
      return true;
    }

    if (this.isJobCancelled(job)) {
      return true;
    }

    if (this.isJobDone(job)) {
      return false;
    }

    if (this.parentJob.task['hasStrictOrder']) {
      const firstChildIndex = this.parentJob.children.findIndex(childJob => this.isJobInProgress(childJob));

      if (firstChildIndex > -1) {
        if (index > firstChildIndex) {
          return true;
        }
      }
    }

    return false;
  }
}
